'use client';

export default function Home() {
  return (
    <>
      <section className="grid grid-cols-2 gap-6"></section>
    </>
  );
}
